// utils/validations/validateInstitutionExcel.js
export const validateInstitutionExcel = (data) => {
    const errors = [];
    // Check if the data is empty
    if (!data || data.length === 0) {
      errors.push("Uploaded Excel file is empty.");
      return errors; // Return early to avoid unnecessary checks
    }
    data.forEach((row, index) => {
      const registrationNumber = String(
        row["Registration Number"] || ""
      ).trim();
      const nameOfInstitution = String(row["Name of Institution"] || "").trim();
      const AddressFullPostalAddress = String(
        row["Address (Full Postal Address)"] || ""
      ).trim();
      const institutionEmail = String(row["Institution Email"] || "").trim();
      const institutionContactNumber = String(
        row["Institution Contact Number"] || ""
      ).trim();
      const ContactPersonName = String(row["Contact Person Name"] || "").trim();
      const ContactPersonDesignation = String(
        row["Contact Person Designation"] || ""
      ).trim();
      const contactPersonEmail = String(
        row["Contact Person Email"] || ""
      ).trim();
      const contactPersonContactNumber = String(
        row["Contact Person Contact Number"] || ""
      ).trim();
      const AffiliatedSportsBody = String(
        row["Affiliated Sports Body"] || ""
      ).trim();
      const AffiliationNumber = String(row["Affiliation Number"] || "").trim();
      const Accreditation = String(
        row[
        "Accreditation Status (1-Accredited, 2-Not Accredited, 3-In Process)"
        ] || ""
      ).trim();

      if (registrationNumber === "") {
        errors.push(`Row ${index + 1}: Registration Number must not be empty.`);
      }
     

      if (nameOfInstitution === "") {
        errors.push(`Row ${index + 1}: Name of Institution must not be empty.`);
       
      }
      if (AddressFullPostalAddress === "") {
        errors.push(
          `Row ${index + 1
          }: Name of Address Full Postal Address must not be empty.`
        );
      }

      if (institutionEmail === "") {
        errors.push(`Row ${index + 1}: Name of Institution Email must not be empty.`);
      } else if (!/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(institutionEmail)) {
        errors.push(`Row ${index + 1}: Institution Email is invalid.`);
      }

      if (ContactPersonName === "") {
        errors.push(
          `Row ${index + 1}: Name of Contact Person Name must not be empty.`
        );
      }
    
      if (ContactPersonDesignation === "") {
        errors.push(
          `Row ${index + 1
          }: Name of Contact Person Designation must not be empty.`
        );
      }
    
      if (contactPersonContactNumber === "") {
        errors.push(
          `Row ${index + 1
          }: Name of Contact Person Contact Number must not be empty.`
        );
      }
      else if (!/^\d{10}$/.test(contactPersonContactNumber)) {
        errors.push(
          `Row ${index + 1
          }: Contact Person Contact Number must be a 10-digit number.`
        );
      }

      if (AffiliatedSportsBody === "") {
        errors.push(
          `Row ${index + 1}: Name of Affiliated Sports Body must not be empty.`
        );
      }
      
    });
    return errors;
};
